export const sensorsViewValidations = {
  data() {
    return {
      editSensorFormRules: {
        sensor_type: [
          {
            required: true,
            validator: this.$t("sensors.validations.enter_sensor_type"),
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: this.$t("sensors.validations.enter_name"),
            trigger: "blur",
          },
        ],
        sensing_radius: [
          {
            required: true,
            message: this.$t("sensors.validations.enter_sensing_radius"),
            trigger: "blur",
          },
        ],
        altitude: [
          {
            required: true,
            message: this.$t("sensors.validations.enter_altitude"),
            trigger: "blur",
          },
        ],
        latitude: [
          {
            required: true,
            message: this.$t("sensors.validations.enter_latitude"),
            trigger: "blur",
          },
        ],
        longitude: [
          {
            required: true,
            message: this.$t("sensors.validations.enter_longitude"),
            trigger: "blur",
          },
        ],
      },
    };
  },
};
